import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "modal-header" };
const _hoisted_2 = { class: "modal-title" };
const _hoisted_3 = { class: "modal-body" };
const _hoisted_4 = { class: "product-info" };
const _hoisted_5 = { class: "product-image" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { class: "product-details" };
const _hoisted_8 = { class: "product-name" };
const _hoisted_9 = { class: "product-description" };
const _hoisted_10 = { class: "options-section" };
const _hoisted_11 = { class: "options-list" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "supplement-info" };
const _hoisted_14 = { class: "supplement-name" };
const _hoisted_15 = { class: "supplement-checkbox" };
const _hoisted_16 = {
    key: 0,
    class: "selected-options-section"
};
const _hoisted_17 = { class: "selected-options-title" };
const _hoisted_18 = { class: "selected-option" };
const _hoisted_19 = { class: "selected-option-name" };
const _hoisted_20 = { class: "modal-footer" };
const _hoisted_21 = { class: "total-price" };
const _hoisted_22 = { class: "price-value" };
const _hoisted_23 = { class: "action-buttons" };
import { ref, computed, watch } from "vue";
import htmlToText from "@/utils/html-to-text";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdditionalFeaturesModal',
    props: {
        product: {},
        selectedSize: {},
        visible: { type: Boolean }
    },
    emits: ["close", "add-to-cart"],
    setup(__props, { emit: __emit }) {
        const store = useStore();
        const props = __props;
        const emit = __emit;
        const selectedFeature = ref("");
        const quantity = ref(1);
        const selectedOptions = computed(() => {
            return selectedFeature.value ? [selectedFeature.value] : [];
        });
        const hasSelectedOptions = computed(() => selectedOptions.value.length > 0);
        watch(() => props.product, (newProduct) => {
            selectedFeature.value = "";
            quantity.value = 1;
        }, { immediate: true });
        const getFeatureName = (option) => {
            if (!option)
                return "";
            return typeof option === "string" ? option : option.name || "";
        };
        const getFeatureKey = (option) => {
            if (!option)
                return "";
            return typeof option === "string" ? option : option.id || option.name;
        };
        const isSelected = (option) => {
            const key = getFeatureKey(option);
            const selectedKey = getFeatureKey(selectedFeature.value);
            return key === selectedKey;
        };
        const selectFeature = (option) => {
            const key = getFeatureKey(option);
            const selectedKey = getFeatureKey(selectedFeature.value);
            if (key === selectedKey) {
                selectedFeature.value = "";
            }
            else {
                selectedFeature.value = option;
            }
        };
        const incrementQuantity = () => {
            quantity.value++;
        };
        const decrementQuantity = () => {
            if (quantity.value > 1)
                quantity.value--;
        };
        const formatPrice = (price) => `${price.toFixed(2)} CHF`;
        const calculateTotal = () => {
            if (!props.selectedSize)
                return 0;
            const isDelivery = store.getters["orderType/isDelivery"];
            const basePrice = isDelivery && props.selectedSize.priceLivraison
                ? parseFloat(props.selectedSize.priceLivraison) || 0
                : parseFloat(props.selectedSize.price) || 0;
            return basePrice * quantity.value;
        };
        const closeModal = () => {
            selectedFeature.value = "";
            quantity.value = 1;
            emit("close");
        };
        const handleAddToCart = () => {
            if (!props.product || !props.selectedSize)
                return;
            const sizeWithOriginalPrices = {
                ...props.selectedSize,
                price: props.selectedSize.price,
                priceLivraison: props.selectedSize.priceLivraison,
            };
            if (selectedFeature.value) {
                store.dispatch("features/toggleFeature", selectedFeature.value);
            }
            const cartIngredients = (props.product.ingredients || []).map((ing) => ({
                id: ing.id,
                name: ing.name,
                extra_cost_price: ing.price || 0,
                quantity: ing.isDefault ? 1 : 0,
                isDefault: ing.isDefault,
                size: props.selectedSize?.name || props.selectedSize?.size || "",
            }));
            const event = {
                product: props.product,
                size: sizeWithOriginalPrices,
                quantity: quantity.value,
                ingredients: cartIngredients,
                supplements: [],
                additionnal: selectedOptions.value,
                notes: "",
            };
            emit("add-to-cart", event);
            closeModal();
        };
        return (_ctx, _cache) => {
            return (__props.visible && __props.product)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-overlay",
                    onClick: closeModal
                }, [
                    _createElementVNode("div", {
                        class: "modal-content",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('pos.customizeOptions')), 1),
                            _createElementVNode("button", {
                                onClick: closeModal,
                                class: "close-button"
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                ]))])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("img", {
                                        src: __props.product.image || '/imgs/product-placeholder.jpg',
                                        alt: __props.product.name,
                                        class: "product-img"
                                    }, null, 8, _hoisted_6)
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("h3", _hoisted_8, _toDisplayString(__props.product.name), 1),
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(htmlToText)(__props.product.description || "")), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "options-title" }, "Choisissez une option", -1)),
                                _createElementVNode("div", _hoisted_11, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.additionnal, (option) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: option,
                                            class: _normalizeClass(["supplement-card", { selected: isSelected(option) }]),
                                            onClick: ($event) => (selectFeature(option))
                                        }, [
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("span", _hoisted_14, _toDisplayString(getFeatureName(option)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("i", {
                                                    class: _normalizeClass(selectedFeature.value === option
                                                        ? 'fas fa-dot-circle'
                                                        : 'far fa-circle')
                                                }, null, 2)
                                            ])
                                        ], 10, _hoisted_12));
                                    }), 128))
                                ])
                            ]),
                            (hasSelectedOptions.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.$t('pos.selectedOption')), 1),
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(getFeatureName(selectedFeature.value)), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "price-label" }, "Total :", -1)),
                                _createElementVNode("span", _hoisted_22, _toDisplayString(formatPrice(calculateTotal())), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("button", {
                                    onClick: closeModal,
                                    class: "cancel-btn"
                                }, _toDisplayString(_ctx.$t('common.cancel')), 1),
                                _createElementVNode("button", {
                                    onClick: handleAddToCart,
                                    class: "add-to-cart-btn"
                                }, [
                                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-shopping-cart" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('pos.addToCart')), 1)
                                ])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
